"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactHookForm = require("react-hook-form");
var _ui = require("../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Input = function Input(_ref) {
  var inputProps = _ref.inputProps,
    control = _ref.control,
    inputComponent = _ref.inputComponent,
    _ref$withFeedback = _ref.withFeedback,
    withFeedback = _ref$withFeedback === void 0 ? true : _ref$withFeedback;
  var _useController = (0, _reactHookForm.useController)({
      name: inputProps.name,
      control: control,
      defaultValue: inputProps.defaultValue
    }),
    _useController$field = _useController.field,
    ref = _useController$field.ref,
    _onChange = _useController$field.onChange,
    _onBlur = _useController$field.onBlur,
    value = _useController$field.value,
    _useController$fieldS = _useController.fieldState,
    invalid = _useController$fieldS.invalid,
    error = _useController$fieldS.error;
  var Component = inputComponent !== null && inputComponent !== void 0 ? inputComponent : _ui.Input;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Component, _extends({}, inputProps, {
    value: value,
    innerRef: ref,
    invalid: invalid,
    onChange: function onChange(e) {
      _onChange(e);
      if (inputProps.onChange) inputProps.onChange(e);
    },
    onBlur: function onBlur(e) {
      _onBlur();
      if (inputProps.onBlur) inputProps.onBlur(e);
    }
  })), error && withFeedback && /*#__PURE__*/_react.default.createElement(_ui.FormFeedback, {
    valid: false
  }, error === null || error === void 0 ? void 0 : error.message));
};
exports.Input = Input;